import { SplashScreenType } from '@/app/models/SplashScreenType';
import { SplashScreenMedia } from '@/app/modules/interface-appearance/SplashScreenMedia';
import { useInterfaceAppearance } from '@/app/modules/interface-appearance/useInterfaceAppearance';

const PageLoading = () => {
  const { appearance } = useInterfaceAppearance();
  const systemName = appearance.system_name;
  const mediaSource = appearance.splash_media?.public_url;
  const splashType =
    appearance.splash_type?.value === SplashScreenType.LOTTIE ? SplashScreenType.LOTTIE : SplashScreenType.IMAGE;

  return (
    <section
      aria-label="Carregando página"
      className="d-flex flex-column align-items-center justify-content-center px-5 py-10 text-center"
      style={{ minHeight: '60vh' }}
    >
      <SplashScreenMedia source={mediaSource} systemName={systemName} type={splashType} />
      <div className="d-flex align-items-center gap-4 mt-5">
        <span aria-hidden="true" className="loader" />
        <output className="fs-5 fw-semibold text-gray-600">Carregando página...</output>
      </div>
    </section>
  );
};

export default PageLoading;
